import { ativarAppCheck, erroDeVerificacao, MENSAGEM_VERIFICACAO } from "./appCheck";

// Calls use the customer Firebase app, never the management session.
async function chamar(nome, dados) {
  const [{ getFunctions, httpsCallable }, { clienteAuth }] = await Promise.all([
    import("firebase/functions"), import("./clienteAuth"),
  ]);
  ativarAppCheck(clienteAuth.app); // já ativo pela página da loja; garante se vier de outro lugar
  const resposta = await httpsCallable(getFunctions(clienteAuth.app, "us-central1"), nome)(dados);
  return resposta.data;
}

export function normalizarCupom(value) {
  return String(value || "").trim().toUpperCase();
}

export function validarCarrinhoLoja(vendedorId, itens, codigo = "") {
  return chamar("validarCupomLoja", {
    vendedorId, codigo: normalizarCupom(codigo), itens: itens.map(({ id, qtd }) => ({ id, qtd })),
  });
}

export function enviarPedidoLoja({ vendedorId, itens, codigo, metodo, requestId, totalConfirmado, pagamentoOnline }) {
  return chamar("criarPedidoLoja", {
    vendedorId, codigo: normalizarCupom(codigo), itens: itens.map(({ id, qtd }) => ({ id, qtd })),
    metodo, requestId, totalConfirmado,
    // "mercadopago": o pedido só vale para a loja depois do pagamento confirmado
    ...(pagamentoOnline ? { pagamentoOnline } : {}),
  });
}

const chave = vendedorId => `loja_cupom_v1_${vendedorId}`;
export function lerCupomLoja(vendedorId) {
  if (!vendedorId) return "";
  try { return normalizarCupom(sessionStorage.getItem(chave(vendedorId))); } catch { return ""; }
}
export function salvarCupomLoja(vendedorId, codigo) {
  if (!vendedorId) return;
  try {
    if (codigo) sessionStorage.setItem(chave(vendedorId), normalizarCupom(codigo));
    else sessionStorage.removeItem(chave(vendedorId));
  } catch {}
}

export function mensagemPedidoLoja(error) {
  const code = error?.code || "";
  if (erroDeVerificacao(error)) return MENSAGEM_VERIFICACAO;
  if (code.includes("unauthenticated")) return "Sua sessão precisa ser confirmada. Entre novamente para continuar.";
  if (code.includes("unavailable") || code.includes("deadline-exceeded") || code.includes("internal")) return "Não foi possível conferir os valores agora. Verifique a conexão e tente novamente.";
  if (error?.details?.motivo === "total-alterado") return "O valor do pedido mudou. Confira o novo total e gere um novo PIX, se necessário.";
  if (["invalid-argument", "failed-precondition", "not-found", "permission-denied", "resource-exhausted"].some(c => code.endsWith(c))) return error.message || "Confira os itens e o cupom antes de continuar.";
  return "Não foi possível concluir. Tente novamente em instantes.";
}
